import { render, staticRenderFns } from "./whyNeuroLeap.vue?vue&type=template&id=99c496b2&scoped=true"
import script from "./whyNeuroLeap.vue?vue&type=script&lang=js"
export * from "./whyNeuroLeap.vue?vue&type=script&lang=js"
import style0 from "./whyNeuroLeap.vue?vue&type=style&index=0&id=99c496b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c496b2",
  null
  
)

export default component.exports